/** API Endpoints */

import { environment } from '../../../environments/environment';

/** Dynamic endpoint builders */

// Auth endpoints (public)
export const OPE_AUTH_CSRF = `${environment.apiUrl}/public/auth/csrf`;
export const OPE_AUTH_SEND_OTP_EMAIL = `${environment.apiUrl}/public/auth/send-otp/email`;
export const OPE_AUTH_SEND_OTP_PHONE = `${environment.apiUrl}/public/auth/send-otp/phone`;
export const OPE_AUTH_VERIFY_OTP = `${environment.apiUrl}/public/auth/verify-otp`;

// Application endpoints (public)
export const OPE_APPLICATION_CREATER = `${environment.apiUrl}/public/application/create`;

// Application endpoints (internal)
export const OPE_APPLICATION_ACCEPT = `${environment.apiUrl}/internal/application/accept`;
export const OPE_APPLICATION_DECLINE = `${environment.apiUrl}/internal/application/decline`;
